/** @format */

import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { showNotification } from "@mantine/notifications";
import { AiOutlineSearch } from "react-icons/ai";

import {
  ActionIcon,
  Badge,
  Button,
  Input,
  Pagination,
  Select,
  Skeleton,
  Table,
  Text,
  CloseButton,
} from "@mantine/core";
import { DatePicker } from "@mantine/dates";
import { Eye } from "tabler-icons-react";
import { format, formatISO } from "date-fns";
import { useDebouncedValue } from "@mantine/hooks";
import {
  getValueForInput,
  loadingStates,
  csvDownload,
  formatDate,
} from "../../utilities/utilities";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import {
  fetchRenewalsCSV,
  getAgreementInRenewalsList,
  getAgreementTypesApi,
  getAgreementsCsvDownload,
  updateRenewalStatus,
} from "../../utilities/apis/agreements";
import { agreementStatusColors } from "../../utilities/enums";
import Styles from "./AgreementsListingPage.module.css";
import HamburgerMenuAgreements from "../HamburgerMenuAgreements";

const statusOptions = [
  {
    label: "Pending with Company",
    value: "Pending with Company",
  },
  {
    label: "TP",
    value: "TP",
  },
];

const AgreementsExpired = () => {
  const location = useLocation();
  const initialTab = location.state?.tab === "expired" ? "expired" : "renewals";
  const [tabName, setTabName] = useState(initialTab);
  const [pageRenewals, setPageRenewals] = useState(1);
  const [pageExpired, setPageExpired] = useState(1);
  const [actionId, setActionId] = useState(null);
  const [configRenewals, setConfigRenewals] = useState({
    loading: loadingStates.LOADING,
    data: null,
  });
  let mainData;
  const [configExpired, setConfigExpired] = useState({
    loading: loadingStates.LOADING,
    data: null,
  });

  const fetchExpired = async () => {
    const response = await apiWrapWithErrorWithData(
      getAgreementInRenewalsList({ page: pageExpired, tabName: "expired" }),
    );
    setConfigExpired({
      loading: loadingStates.NO_ACTIVE_REQUEST,
      data: response,
    });
  };
  useEffect(() => {
    fetchExpired();
  }, [pageExpired]);

  const fetchRenewals = async () => {
    const response = await apiWrapWithErrorWithData(
      getAgreementInRenewalsList({ page: pageRenewals, tabName: "renewals" }),
    );
    setConfigRenewals({
      loading: loadingStates.NO_ACTIVE_REQUEST,
      data: response,
    });
  };
  useEffect(() => {
    fetchRenewals();
  }, [pageRenewals]);
  useEffect(() => {
    if (tabName === "renewals") {
      mainData = configRenewals;
    } else if (tabName === "expired") {
      mainData = configExpired;
    }
  }, [tabName, configExpired, configRenewals]);

  if (tabName === "renewals") {
    mainData = configRenewals;
  } else if (tabName === "expired") {
    mainData = configExpired;
  }
  const navigate = useNavigate();
  const onClick = (agreementId) => {
    navigate(`/app/agreements_manager/agreements/details/${agreementId}`);
  };
  let srNo;
  if (tabName === "expired") {
    srNo = (pageExpired - 1) * 10 + 1;
  }
  if (tabName === "renewals") {
    srNo = (pageRenewals - 1) * 10 + 1;
  }

  function convertToISOFormat(dateStr) {
    const [day, month, year] = dateStr.split("-");
    return `${year}-${month}-${day}`;
  }
  const onViewClick = (agreementId) => {
    navigate(`/app/agreements_manager/agreements/details/${agreementId}`);
  };
  function getDaysDifference(targetDate) {
    const currentDate = new Date();
    const target = new Date(targetDate);
    const timeDifference = target - currentDate;
    const daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
    return daysDifference;
  }
  const handleCsvDownload = async () => {
    const response = await apiWrapWithErrorWithData(
      fetchRenewalsCSV({ tabName }),
    );
    if (response.success) {
      if (response?.csvData.length > 0) {
        const columnHeaders = Object.keys(response.csvData[0]);
        csvDownload({
          data: response.csvData,
          headers: columnHeaders,
          name: `agreements ${tabName} list`,
        });
      } else {
        showNotification({
          title: "Agreement csv download",
          message: "No agreement available",
          color: "red",
        });
      }
    }
  };

  const handleAgreementRenewal = async () => {
    const response = await apiWrapWithErrorWithData(
      updateRenewalStatus({ id: actionId, status: "RENEWED" }),
    );
    if (response.success) {
      navigate(`/app/agreements_manager/agreements/new?ag=${actionId}`);
    }
  };

  const handleAgreementClose = async () => {
    const response = await apiWrapWithErrorWithData(
      updateRenewalStatus({ id: actionId, status: "CLOSED" }),
    );
    if (response.success) {
      window.location.reload();
    }
  };

  return (
    <>
      <div
        className="flex"
        style={{
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "12px",
        }}
      >
        <h1
          style={{
            fontSize: "22px",
            fontWeight: "600",
            letterSpacing: "1px",
            textTransform: "lowercase",
            fontFamily: "lexend",
            whiteSpace: "nowrap",
            paddingBottom: "13px",
            position: "relative",
            color: "black",
          }}
        >
          renewals
        </h1>

        <HamburgerMenuAgreements />
      </div>
      <div className="flex justify-around items-center mt-4 hover:text-co">
        <Button
          className="hover:bg-blue-500 hover:text-white"
          variant="outline"
          color="blue"
          onClick={() => setTabName("renewals")}
        >
          renewals
        </Button>
        <Button
          className="hover:bg-red-500 hover:text-white"
          variant="outline"
          color="red"
          onClick={() => setTabName("expired")}
        >
          expired
        </Button>
      </div>

      <div className="flex flex-col">
        <div className="flex justify-between my-4">
          <Text>{tabName === "renewals" ? "expiring soon" : "expired"}</Text>
          <Button
            className="mx-2 btn btn-success btn-lg float-right"
            // disabled={exportButtonLoading}
            onClick={handleCsvDownload}
            // color={themeColor(colors.agreement)}
            style={{
              backgroundColor: "#46BDE1",
            }}
          >
            export
          </Button>
        </div>
      </div>

      {mainData.loading === loadingStates.LOADING && (
        <div className="flex flex-col">
          {Array.from({ length: 10 }).map((i) => (
            <Skeleton key={i} height={30} radius="md" className="my-1 w-full" />
          ))}
          <div className="flex flex-row justify-center">
            <Skeleton height={40} radius="md" className="w-40" />
          </div>
        </div>
      )}
      {mainData.loading === loadingStates.NO_ACTIVE_REQUEST &&
        Boolean(mainData.data?.agreementsCount) && (
          <div className="flex flex-col">
            <Table striped>
              <thead>
                <tr>
                  <th>sr no.</th>
                  <th>ain</th>
                  <th>type</th>
                  <th>business unit</th>
                  <th>second party</th>
                  <th>start date</th>
                  <th>end date</th>
                  {/* <th>ageing</th> */}
                  {tabName === "renewals" && <th>{"due days"}</th>}
                  <th>&nbsp;</th>
                  <th>&nbsp;</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                {mainData.data.agreements
                  .filter(
                    (v) =>
                      v.agreementData.json &&
                      v.agreementData.json.typeOfAgreement,
                  )
                  .map((row) => (
                    <tr key={row.id}>
                      <td>{srNo++}</td>
                      <td>{`agreement-${row.id}`}</td>

                      <td>{row.agreementData.json.typeOfAgreement}</td>
                      <td>
                        {row.agreementData?.json?.location
                          ? row.agreementData?.json?.location
                          : row.agreementData?.json?.location}
                      </td>
                      <td>
                        {row.agreementData?.json?.secondParty?.name || "-"}
                      </td>
                      <td>{formatDate(row.contractStartDate) || "-"}</td>
                      <td> {formatDate(row.contractEndDate) || "-"}</td>
                      {/* <td>{row.ageing || "-"}</td> */}
                      {tabName === "renewals" && (
                        <td>
                          {getDaysDifference(row.contractEndDate) + "-days"}
                        </td>
                      )}
                      <td>
                        <div className="flex flex-row mr-4">
                          <a
                            href={`/app/agreements_manager/agreements/details/${row.id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <Eye color="#46BDE1" size={24} />
                          </a>
                        </div>
                      </td>
                      <td>
                        <Button
                          onClick={() => {
                            setActionId(row.id);
                            handleAgreementRenewal();
                          }}
                          color="blue"
                          variant="outline"
                        >
                          renew
                        </Button>
                      </td>
                      <td>
                        <Button
                          // onClick={() => {
                          //   setActionId(row.id);
                          //   handleAgreementClose();
                          // }}
                          onClick={() =>
                            navigate(
                              `/app/agreements_manager/agreements/details/${row.id}?close=true`,
                            )
                          }
                          color="red"
                        >
                          close
                        </Button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          </div>
        )}
      {mainData.loading !== loadingStates.LOADING &&
      !mainData.data?.agreementsCount ? (
        <div
          className="flex justify-center items-center"
          style={{
            minHeight: "300px",
          }}
        >
          no agreements
        </div>
      ) : null}
      {mainData.data?.agreementsCount ? (
        <div className="flex flex-row justify-center my-4">
          <Pagination
            page={tabName === "renwals" ? pageRenewals : pageExpired}
            onChange={(page) => {
              if (tabName === "renewals") {
                setPageRenewals(page);
              } else if (tabName === "expired") {
                setPageExpired(page);
              }
            }}
            total={Math.ceil(mainData.data.agreementsCount / 10)}
          />
        </div>
      ) : null}
    </>
  );
};

export default AgreementsExpired;
